import {SEmployee} from '../../shared/employees-list/list/employee-list.interfaces';
import {TreeNode} from '../../shared/ui';
import {TreeItem} from '../../shared/ui/tree-multi-select/treeview.component';

export interface PossibleRights {
  repCriterionList: RepCriterion[];
  empCriterionList: Criterion[];
  email: string;
  login: string;
  profilesList: Profile[];
  additionalProfilesList?: Profile[];
}

export interface CurrentRights extends PossibleRights {
  lastConnection: string;
  accessEndDate: Date;
  profileExclusionReason?: 'CONFIDENTIALITY_LEVEL' | 'OFFERING' | 'UNKNOWN';
  profileExclusionTransId?: string;
  profileExclusionBypassConfidentiality?: boolean;
  accessOwnContracts?: boolean;
}

export interface Profile {
  id: string;
  roles: string[];
  transId: string;
  name: string;
  descriptionTransId: string;
  confidentialityLevel?: string;
}

export interface RepCriterion extends Criterion {
  entityType: string;
}

export interface Criterion {
  access: string;
  id: number;
  value: any;
  zoneName: string;
  transId?: string;
}

export interface PopulationAccessCriterionValue {
  [key: string]: PopulationAccessCriterionZoneValue;
}

export interface PopulationAccessCriterionZoneValue {
  type: string;
  value: string | number | boolean;
  transId?: string | boolean;
  metaData?: TreeNode<TreeItem>[];
}

export interface ContractIndexCriteriaMapping {
  data: string;
  value: string | number | boolean;
}

export interface EmpPopulationCriterion {
  id?: number;
  zoneName: string;
  groupZoneName: string;
  value: PopulationAccessCriterionValue;
  access: string;
  contractIndexCriteriaMapping: ContractIndexCriteriaMapping;
  metaData?: any;
  readableName?: string;
}

export interface RepPopulationCriterion {
  id?: number;
  entityType: string;
  zoneName: string;
  groupZoneName: string;
  value?: PopulationAccessCriterionValue;
  access: string;
}

export interface ListItem {
  id: string;
  text: string;
}

export interface SelectValue extends ListItem {
  descriptionTransId?: string;
}

export interface CriterionList {
  [key: string]: CriterionOptions;
}

export interface CriterionOptions {
  readonly key: string;
  readonly title: string;
  readonly saveKey: string;
  readonly fields: CriterionField[];
  criterionList: Criterion[];
  criterionObject: { [key: string]: any };
  possibleRights: Criterion[];
  errorMessage?: string;
}

export interface CriterionField {
  readonly title: string;
  readonly name: string;
}

export enum CriterionListType {
  REP_CRITERION_LIST = 'repCriterionList',
  EMP_CRITERION_LIST = 'empCriterionList'
}

export interface SelectedEmployee {
  employee: SEmployee;
  search: string;
  isExternalAdmin: boolean;
  page: number;
}
